{
  "SET_NEW_PASSWORD": {
    "TITLE": "رمز جدید",
    "PASSWORD": {
      "LABEL": "رمز عبور",
      "PLACEHOLDER": "رمز عبور",
      "ERROR": "رمز عبور خیلی کوتاه است."
    },
    "CONFIRM_PASSWORD": {
      "LABEL": "تکرار رمز عبور",
      "PLACEHOLDER": "لطفا رمز عبور را مجددا وارد کنید",
      "ERROR": "تکرار رمز عبور می‌بایست با رمز عبور یکسان باشد."
    },
    "API": {
      "SUCCESS_MESSAGE": "رمز عوض شد.",
      "ERROR_MESSAGE": "متاسفانه ارتباط با سرور برقرار نشد، مجددا امتحان کنید"
    },
    "CAPTCHA": {
      "ERROR": "تأیید اعتبار منقضی شد. لطفا دوباره کپچا را حل کنید."
    },
    "SUBMIT": "ثبت"
  }
}
